/* istanbul ignore file: we do not need to care about the entry point file as errors are detected through integration tests (E2E) */

/**
 * The entry point for dashboard meta box
 */
import "@wpnotes/utils"; // Import once for startup polyfilling (e. g. setimmediate)
import { render } from "react-dom";
import { DashboardComponent } from "./components";
import React from "react";
import { RootStore } from "./store";
import "./style/dashboard.scss";

const node = document.getElementById(`bdotstd-dashboard-list-component`);

if (node) {
    render(
        <RootStore.StoreProvider>
            <DashboardComponent />
        </RootStore.StoreProvider>,
        node
    );
}

export * from "@wpnotes/utils";
export * from "./wp-api";
export * from "./store";
